<script>

// import MeetingScholarshipAchievementCard from "../../Cards/Meeting/MeetingScholarshipAchievementCard.vue";
import {mapState} from "vuex";

const MeetingScholarshipAchievementCard = () => ({
  component: import("../../Cards/Meeting/MeetingScholarshipAchievementCard.vue"),
  // loading: LoadingComponent,
  // error: ErrorComponent,
  delay: 200,
  timeout: 3000
});


export default {
  name: "TheMeetingScholarshipAchievementsStatementTable",

  components: {
    MeetingScholarshipAchievementCard,
  },

  watch: {
    statement() {
      if (_.isEmpty(this.statement)) this.page = 1;
    },
  },

  props: {
    achievements: Array,
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 999,
    }
  },

  computed: {

    ...mapState({
      statement: state => state.scholarship_competition.statement,
    }),

    numberOfPages () {
      return Math.ceil(this.achievements.length / this.itemsPerPage)
    },

  },

  methods: {
    openEditAchievement(achievement) {
      this.$emit('openEditAchievement', achievement);
    }
  },
}
</script>

<template>
  <v-data-iterator
    :items="achievements"
    :items-per-page.sync="itemsPerPage"
    :page="page"
    hide-default-footer
  >

    <template #header>
      <v-card-title class="py-2">
        Достижения прикрепленные к заявлению

        <v-spacer/>

      </v-card-title>
      <v-divider/>
    </template>

    <template #default="props">
      <v-row
        no-gutters
        class="overflow-y-auto ma-0 pa-0"
        :style="{'height': 'calc(100vh - 200px)'}"
      >
        <v-col
          v-for="item in props.items"
          :key="item.id"
          cols="12"
        >
          <meeting-scholarship-achievement-card
            :achievement="item"
            @openEditAchievement="openEditAchievement"
            @openAchievement="$emit('openAchievement', $event)"
          />
           <v-divider/>
        </v-col>
      </v-row>
    </template>

    <template #footer>
      <v-divider/>
      <div  class="py-2 pl-3">
        Всего достижений: {{achievements.length}}
      </div>

    </template>

  </v-data-iterator>
</template>

<style scoped>

</style>